const Bus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <defs>
        <clipPath id="a">
          <rect
            width="28"
            height="28"
            transform="translate(-349 4088)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(349 -4088)">
        <path
          d="M.2,4.725,1.549,1.744A2.994,2.994,0,0,1,4.261,0H23.655a2.6,2.6,0,0,1,2.594,2.594V9.078A1.424,1.424,0,0,1,24.828,10.5H22.706a2.187,2.187,0,0,1-4.287,0H7.831a2.187,2.187,0,0,1-4.287,0H1.216A1.217,1.217,0,0,1,0,9.284V5.631a2.179,2.179,0,0,1,.2-.906Zm.948.029,4.1-.344V2.572L2.3,2.2Zm19.418,6.621a1.312,1.312,0,1,0-1.312-1.312A1.313,1.313,0,0,0,20.562,11.375Zm-14.875,0a1.312,1.312,0,1,0-1.312-1.312A1.313,1.313,0,0,0,5.687,11.375ZM1.216,9.625H3.543a2.187,2.187,0,0,1,4.287,0H18.418a2.187,2.187,0,0,1,4.287,0h2.122a.548.548,0,0,0,.547-.547V2.594A1.721,1.721,0,0,0,23.655.875H4.261A2.109,2.109,0,0,0,2.878,1.4l2.836.354H22.749a.438.438,0,0,1,.438.438V4.812a.438.438,0,0,1-.437.438H5.705l-4.831.4V9.284a.342.342,0,0,0,.341.341Zm21.1-5.25V2.625H19.249v1.75Zm-3.938-1.75h-3.5v1.75h3.5ZM14,2.625H10.937v1.75H14Zm-3.937,0H6.124v1.75h3.938Zm0,0"
          transform="translate(-348.124 4095.875)"
        />
      </g>
    </svg>
  );
};

export default Bus;
